import React, { useEffect } from 'react';
import { Dispatch } from 'redux';
import { Layouts } from 'app-components';

import { useAppDispatch } from '../../../hooks';
import NavBarContainer from '../../../containers/common/NavBarContainer';
import AdminProvisionContainer from './AdminProvisionContainer';
import { fetchAdminPrivilegesInfo } from '../../../actions/admin/adminProvisionActionCreators';

const adminProvision = () => {
    const dispatch: Dispatch<any> = useAppDispatch();

    useEffect(() => {
        dispatch(fetchAdminPrivilegesInfo());
    }, []);

    return (
        <Layouts id="admin-provision">
            <Layouts.Row hasGap={true}>
                <div className="grid-col-12" data-testid="admin-provision-navbar-container">
                    <div className="grid-row" data-testid="admin-provision-navbar-inner-container">
                        <NavBarContainer navBarClass="ticket-mgmt-top-nav grid-col-12" />
                    </div>
                </div>
                <div
                    className="desktop:grid-col-12"
                    id="main-content"
                    data-testid="admin-provision-provision-container"
                >
                    <AdminProvisionContainer />
                </div>
            </Layouts.Row>
        </Layouts>
    );
};

export default adminProvision;
